// src/services/api.ts
import { BusinessDetails, ContactDetails, OwnerDetails, PanVerificationResponse, RegistrationData } from '../types/registration';
import { AxiosRequestConfig } from "axios";
import { convertFileToBase64 } from 'pages/CreateRemit/documentation';
import { apis } from "service";

const BASE_URL = 'https://xxl6-bbr3-kxzs.m2.xano.io/api:'
const step1 = BASE_URL + 'EetDwnQJ/channels/step1_v3'
const step2 = BASE_URL + 'EetDwnQJ/channels/step2_v3'
const step3 = BASE_URL + 'EetDwnQJ/channels/step3_v3';
const verify_existing_email = BASE_URL + 'EetDwnQJ/channel_exists';
const GET_RELATIONSHIP_MANAGER = BASE_URL + 'gfz8um1p/staff_quickview'
const GET_PAN_INFO = BASE_URL + 'EetDwnQJ/getPanInfo_v3';
const step2_fallback = BASE_URL + 'EetDwnQJ/channels/step2_v3_fallback';
const step3_fallback = BASE_URL + 'EetDwnQJ/channels/step3_fallback_v3';
const get_commission_rates = BASE_URL + 'CwCdonPE/default_commision_rates';
const final_registration_step = BASE_URL + 'EetDwnQJ/channels/step5_v1';
const get_current_step = BASE_URL + 'EetDwnQJ/channels/getStep_v3/:id/';
const get_fields_steps = 'https://xxl6-bbr3-kxzs.m2.xano.io/api:FiAQK2sE/get_reg_fields';

interface Step1Response {
    id: number;
    created_at: string;
    name: string;
    email: string;
    phone: string;
    type: string;
    relationshil_manager: number;
}

interface Step1RequestData {
    email: string;
    phone: string;
    staff_id: number;
    sub_step?: number; // Optional field for sub-step
    partner_id?: number
}
export interface IAddress {
  pincode: string,
  add_line_1: string,
  add_line_2: string,
  address_type: string,
  documents: {
    doc_id: number,
    file: string
  }[],
}
interface Step2RequestData {
    pan_front: string;
    channels_id: number;
    pan_number: string;
    pan_type: string;
    name: string;
    type: string;
    address: IAddress[];
}

interface Step3FallbackRequestData {
    channels_id: number;
    aadhar_no: string;
    dob: string;
    address: string;
    name: string;
    pan_no: string;
    sub_step?: number; // Optional field for sub-step
}

interface Step2Response {
    id: number;
    created_at: string;
    name: string;
    email: string;
    phone: string;
    type: string;
    relationshil_manager: number;
    status: string;
    level: string;
    parent_channel: number;
    is_branch: boolean;
    masked_pan_no: string;
    pan_type: string;
    logo: FileObject;
    pan: FileObject;
    
}

interface FileObject {
    path: string;
    name: string;
    type: string;
    size: number;
    mime: string;
    meta: Record<string, any>;
    url: string;
}

export interface PanResponse {
    name: string;
    number: string;
    typeOfHolder: string;
    isIndividual: boolean;
    isValid: boolean;
    firstName: string;
    middleName: string;
    lastName: string;
    title: string;
    panStatus: string;
    panStatusCode: string;
    aadhaarSeedingStatus: string;
    aadhaarSeedingStatusCode: string;
    lastUpdatedOn: string;
}

interface Step3RequestData {
    uid_number: string;
    channels_id: number;
    aadhaar_front: string;
    aadhaar_back: string;
    pan_card: string;
    pan_no: string;
}

type PurposeMapper = {
  id: number;
  created_at: number;
  name: string;
  description: string | null;
  tcs_type: string;
  default_default_commission: number;
  default_walkin: number;
  loan: boolean;
  product_id: number;
  mode: string;
};

type CommissionData = {
  id: number;
  created_at: number;
  channel_id: number;
  purpose_id: number;
  charges: number;
  product_id: number;
  ProductSubtype: string;
  producttype_id: number;
  Country_Currency_ISO: string;
  CommisionType: string;
  _purpose_mapper: PurposeMapper;
};

export interface finalRegistrationStepData {
    child_channel: string;
    accept_default: boolean;
    unapproved_commision_rates : any;
    approved_commision_rates: any;
    share_cred?: boolean;
}

interface FieldsAndSteps {
    id: number;
    created_at: string;
    sub_step: number;
    sub_step_field: {
        field: string;
    }[];
}

export const verifyExistingEmail = async (email: string): Promise<{
    id: 0,
    name: string
}> => {
    const payload: AxiosRequestConfig<{ email: string }> = {
        data: { email }
    };

    const response = await apis.post(verify_existing_email, payload);
    return response.data;
}


export const processStep1 = async (data: Partial<ContactDetails>): Promise<Step1Response> => {
    const dataTosend: Step1RequestData = {
        email: data.email || '',
        phone: data.mobile || '',
        staff_id: data.relationshipManager ? parseInt(data.relationshipManager) : 0,
        sub_step: data?.sub_step,
        partner_id: data?.partner_id ? parseInt(data.partner_id) : undefined
    }
    const payload: AxiosRequestConfig<Step1RequestData> = {
        data: dataTosend
    };

    const response = await apis.post(step1, payload);
    return response.data;
}

export const processStep2 = async (data: Partial<BusinessDetails & {addresses: IAddress[]}>): Promise<Step2Response> => {
    const formData = new FormData();
    // if (data.panCard) {
    //     const base64PanCard = await convertFileToBase64(data.panCard);
    //     formData.append('pan_front', base64PanCard);
    // }
    formData.append('channels_id', localStorage.getItem('currentPartnerRegistrationId') || '');
    formData.append('pan_number', data.panNumber || '');
    formData.append('pan_type', data.businessType || '');
    formData.append('name', data.brandName || '');
    formData.append('type', data.category || '');
    data.addresses?.forEach((address) => {
        formData.append('address[]', JSON.stringify(address));
    })
    formData.append('sub_step', data.sub_step?.toString() || ''); // Ensure sub_step is included

    const payload: AxiosRequestConfig<Step2RequestData> = {
        data: formData as any
    };

    const response = await apis.post(step2, payload);
    return response.data;
}

export const getRelationshipManagers = async (): Promise<{ id: string; fname: string }[]> => {
    const response = await apis.get(GET_RELATIONSHIP_MANAGER, {});
    return response.data;
};

export const verifyPan = async (data:{pan_no: string}): Promise<PanResponse> => {
    const payload: AxiosRequestConfig<{ pan_no: string }> = {
        data
    };

    const response = await apis.post(GET_PAN_INFO, payload);
    return response.data
}   

export const processStep3 = async (data: Partial<OwnerDetails>): Promise<any> => {
    const formData = new FormData();
    formData.append('aadhar_no', data.aadhaarNumber || '');
    formData.append('channels_id', localStorage.getItem('currentPartnerRegistrationId') || '');
    formData.append('pan_no', data.panNumber || '');
    formData.append('sub_step', data.sub_step?.toString() || ''); // Ensure sub_step is included

    const payload: AxiosRequestConfig<Step3RequestData> = {
        data: formData as any
    };

    const response = await apis.post(step3, payload);
    return response.data;
}

export const processStep2Fallback = async (data: Partial<BusinessDetails & {addresses: IAddress[]}>): Promise<Step2Response> => {
    const formData = new FormData();
    // if (data.panCard) {
    //     const base64PanCard = await convertFileToBase64(data.panCard);
    //     formData.append('pan_front', base64PanCard);
    // }
    formData.append('channels_id', localStorage.getItem('currentPartnerRegistrationId') || '');
    formData.append('pan_number', data.panNumber || '');
    formData.append('pan_type', data.businessType || '');
    formData.append('name', data.brandName || '');
    formData.append('type', data.category || '');
    data.addresses?.forEach((address) => {
        formData.append('address[]', JSON.stringify(address));
    })
    formData.append('sub_step', data.sub_step?.toString() || ''); // Ensure sub_step is included

    const payload: AxiosRequestConfig<Step2RequestData> = {
        data: formData as any
    };

    const response = await apis.post(step2_fallback, payload);
    return response.data;
}

export const getCommissionByProductId = async (productId: string): Promise<CommissionData[]> => {
    const payload: AxiosRequestConfig<{ product_id: string }> = {
        params:{
            product_id: productId
        }
    }
    const response = await apis.get(get_commission_rates, payload);
    return response.data;
}

export const processStep3Fallback = async (data: Partial<Step3FallbackRequestData>): Promise<any> => {
    const formData = new FormData();    
    formData.append('channels_id', localStorage.getItem('currentPartnerRegistrationId') || '');
    formData.append('pan_no', data.pan_no || '');
    formData.append('dob', data.dob || '');
    formData.append('name', data.name || '');
    formData.append('aadhar_no', data.aadhar_no || '');
    formData.append('address', data.address || '');
    formData.append('sub_step', data.sub_step?.toString() || ''); // Ensure sub_step is included

    const payload: AxiosRequestConfig<Step3FallbackRequestData> = {
        data: formData as any
    };

    const response = await apis.post(step3_fallback, payload);
    return response.data;
}

export const finalRegistrationStep = async (data: Omit<finalRegistrationStepData, 'child_channel'>): Promise<any> => {
    const payload: AxiosRequestConfig<finalRegistrationStepData> = {
        data:{
            child_channel: localStorage.getItem('currentPartnerRegistrationId') || '',
            accept_default: data.accept_default,
            unapproved_commision_rates: data.unapproved_commision_rates,
            approved_commision_rates: data.approved_commision_rates,
            share_cred: data.share_cred
        }
    }
    const response = await apis.post(final_registration_step, payload);
    return response.data;
}

export const getCurrentStep = async (channelId: string): Promise<{step:string, result:any}> => {    
    const url = get_current_step.replace(':id', channelId);
    const response = await apis.get(url, {});
    return response.data;
}

export const getFieldsSteps = async (): Promise<FieldsAndSteps[]> => {
    const response = await apis.get(get_fields_steps, {});
    return response.data;
}








export const apiService = {
    // PAN Verification
    verifyPan: async (panNumber: string) => {
        // const response = await fetch('/api/verify-pan', {
        //   method: 'POST',
        //   headers: { 'Content-Type': 'application/json' },
        //   body: JSON.stringify({ panNumber }),
        // });
        // return response.json();
        return await new Promise((resolve) => {
            setTimeout(() => {
                resolve({
                    panNumber,
                    ownerName: 'John Doe',
                    businessName: 'Doe Enterprises',
                    type: 'business',
                    address: '123 Main St, City, State, 123456',
                });
            }, 1000);
        }) as PanVerificationResponse;
    },

    // Address lookup by PIN code
    getAddressByPin: async (pinCode: string) => {
        const response = await fetch(`/api/address/${pinCode}`);
        return response.json();
    },

    // Get relationship managers
    getRelationshipManagers: async () => {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve([
                    { id: 'rm1', name: 'Relationship Manager 1' },
                    { id: 'rm2', name: 'Relationship Manager 2' },
                ]);
            }, 1000);
        });
    },

    // File upload
    uploadFile: async (file: File, type: string) => {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('type', type);

        const response = await fetch('/api/upload', {
            method: 'POST',
            body: formData,
        });
        return response.json();
    },

    // Submit registration
    submitRegistration: async (data: RegistrationData) => {
        const response = await fetch('/api/register', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data),
        });
        return response.json();
    },
};
